/**
 * Position action types
 */
export var PositionAction;
(function (PositionAction) {
    PositionAction["OPEN"] = "OPEN";
    PositionAction["ADD"] = "ADD";
    PositionAction["REDUCE"] = "REDUCE";
    PositionAction["CLOSE"] = "CLOSE";
    PositionAction["REVERSE"] = "REVERSE";
})(PositionAction || (PositionAction = {}));
//# sourceMappingURL=papertrade.js.map